import { Button, Card, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { useAppSelector, useCrossPopup } from 'shared/lib';

import { selectEarlyRepaymentPopup } from 'features/PostIssuanceHelp/model';

import styles from './EarlyRepaymentPopup.module.scss';

interface IEarlyRepaymentPopupProps {
  visible: boolean;
  onClose: () => void;
}

export const EarlyRepaymentPopup: React.FC<IEarlyRepaymentPopupProps> = ({ visible, onClose }) => {
  const Popup = useCrossPopup();
  const { title, text, advices, buttons } = useAppSelector(selectEarlyRepaymentPopup);
  const isMobile = useIsMobile();

  return (
    <Popup
      className={styles.modal}
      visible={visible}
      onClose={onClose}
    >
      <Popup.Header>
        <Space
          className={styles.header}
          direction="vertical"
          size={12}
        >
          <Typography.Heading level={3}>{title}</Typography.Heading>
          <Typography.Text size={16}>{text}</Typography.Text>
        </Space>
      </Popup.Header>

      <Popup.Content>
        <Space
          direction="vertical"
          size={24}
        >
          <Space
            size={12}
            direction="vertical"
          >
            <Typography.Text
              strong
              size={16}
            >
              {advices.title}
            </Typography.Text>

            <Space
              size={8}
              direction="vertical"
            >
              {advices.list?.map((advice) => (
                <Card
                  color="dark"
                  size={16}
                  key={advice.text}
                >
                  <Space
                    size={8}
                    direction="vertical"
                  >
                    <Typography.Text
                      strong
                      size={16}
                    >
                      {advice.title}
                    </Typography.Text>

                    <Typography.Text size={14}>{advice.text}</Typography.Text>
                  </Space>
                </Card>
              ))}
            </Space>
          </Space>

          <Space justify="end">
            {buttons.map((button) => (
              <Button
                onClick={onClose}
                block={isMobile}
                key={button.title}
              >
                {button.title}
              </Button>
            ))}
          </Space>
        </Space>
      </Popup.Content>
    </Popup>
  );
};
